import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _68217171 = () => interopDefault(import('../pages/driver-index.vue' /* webpackChunkName: "pages/driver-index" */))
const _31c91488 = () => interopDefault(import('../pages/driver-login.vue' /* webpackChunkName: "pages/driver-login" */))
const _a199fed6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0efb88c2 = () => interopDefault(import('../pages/main-index.vue' /* webpackChunkName: "pages/main-index" */))
const _42fc57b2 = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _4b7d2b32 = () => interopDefault(import('../pages/RegisterUser.vue' /* webpackChunkName: "pages/RegisterUser" */))
const _cbf239ba = () => interopDefault(import('../pages/rules.vue' /* webpackChunkName: "pages/rules" */))
const _60be735c = () => interopDefault(import('../pages/profile/driver.vue' /* webpackChunkName: "pages/profile/driver" */))
const _df274d40 = () => interopDefault(import('../pages/profile/passenger.vue' /* webpackChunkName: "pages/profile/passenger" */))
const _28a72d97 = () => interopDefault(import('../pages/profile/reservedTrip.vue' /* webpackChunkName: "pages/profile/reservedTrip" */))
const _28c08736 = () => interopDefault(import('../pages/profile/ticket.vue' /* webpackChunkName: "pages/profile/ticket" */))
const _3235184f = () => interopDefault(import('../pages/profile/trip.vue' /* webpackChunkName: "pages/profile/trip" */))
const _3f4a31a3 = () => interopDefault(import('../pages/profile/wallet.vue' /* webpackChunkName: "pages/profile/wallet" */))
const _34e94504 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _06c65e51 = () => interopDefault(import('../pages/blog/_id.vue' /* webpackChunkName: "pages/blog/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/driver-index",
    component: _68217171,
    name: "driver"
  }, {
    path: "/driver-login",
    component: _31c91488,
    name: "driver-login"
  }, {
    path: "/login",
    component: _a199fed6,
    name: "login"
  }, {
    path: "/main-index",
    component: _0efb88c2,
    name: "main"
  }, {
    path: "/register",
    component: _42fc57b2,
    name: "register"
  }, {
    path: "/RegisterUser",
    component: _4b7d2b32,
    name: "RegisterUser"
  }, {
    path: "/rules",
    component: _cbf239ba,
    name: "rules"
  }, {
    path: "/profile/driver",
    component: _60be735c,
    name: "profile-driver"
  }, {
    path: "/profile/passenger",
    component: _df274d40,
    name: "profile-passenger"
  }, {
    path: "/profile/reservedTrip",
    component: _28a72d97,
    name: "profile-reservedTrip"
  }, {
    path: "/profile/ticket",
    component: _28c08736,
    name: "profile-ticket"
  }, {
    path: "/profile/trip",
    component: _3235184f,
    name: "profile-trip"
  }, {
    path: "/profile/wallet",
    component: _3f4a31a3,
    name: "profile-wallet"
  }, {
    path: "/",
    component: _34e94504,
    name: "index"
  }, {
    path: "/blog/:id?",
    component: _06c65e51,
    name: "blog-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
